function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "param(fill) #FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 1.667C9.875 1.667 1.667 9.875 1.667 20c0 10.125 8.208 18.333 18.333 18.333 10.125 0 18.333-8.208 18.333-18.333C38.333 9.875 30.125 1.667 20 1.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.068 10.908l.1 1.535 3.956-.018-4.596 4.928 1.17 1.092 4.596-4.929.257 3.947 1.538-.007-.429-6.578zM19.165 28.21l-.127-1.533-3.954.088 4.509-5.008-1.19-1.07-4.508 5.007-.327-3.941-1.538.034.545 6.569z"
}));

function SvgMoreViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMoreViews;